import { Vector3 } from 'three'
import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const tutorial1: LevelConfig = {
  grid: [
    padRow(
      ['WE', 'WE', { track: 'WE', vehicle: 'locomotive' }, 'WE', { track: 'WE', exit: 'E' }],
      'fill',
    ),
  ],
  goal: {
    sequence: [],
    message: `Move with   [▲] [▼]   or   [W] [ S ]`,
    messageTouch: `Swipe left or right anywhere
on the screen to move`,
  },
}

export const tutorial2: LevelConfig = {
  grid: [
    ['W', { track: 'WE', vehicle: { type: 'wagon', color: 'blue' } }, 'SW'],
    padRow(
      [null, null, 'NE', 'WE', { track: 'WE', vehicle: 'locomotive' }, { track: 'WE', exit: 'E' }],
      'append',
    ),
  ],
  goal: {
    sequence: ['blue'],
    message: `Drive the locomotive into
wagons to couple them`,
    messageTouch: `Drive the locomotive into
wagons to couple them`,
  },
}

export const tutorial3: LevelConfig = {
  grid: [
    padRow(
      [
        { track: 'WE', exit: 'W' },
        { track: 'WE', vehicle: { type: 'locomotive', direction: -1 } },
        'WE',
        ['WE', 'SW'],
        { track: 'WE', vehicle: { type: 'wagon', color: 'blue', direction: -1 } },
        'E',
      ],
      'prepend',
    ),
    padRow([null, null, null, 'NS'], 'prepend', false, 10),
    padRow(
      [
        null,
        null,
        null,
        'NE',
        { track: 'WE', vehicle: { type: 'wagon', color: 'forestgreen', direction: -1 } },
        'E',
      ],
      'prepend',
      false,
      10,
    ),
  ],
  goal: {
    sequence: ['blue', 'forestgreen'],
    message: `Click on switches to activate them`,
    messageTouch: `Tap on switches to activate them`,
    offset: new Vector3(0.7, 0, 0.25),
  },
}

export const tutorial4: LevelConfig = {
  grid: [
    padRow([null, null, null, null, 'SE', 'WE', 'E'], 'prepend', false),
    padRow(
      [
        { track: 'WE', exit: 'W' },
        { track: 'WE', vehicle: { type: 'locomotive', direction: -1 } },
        'WE',
        'WE',
        { track: ['WE', 'NW'] },
        'WE',
        { track: 'WE', vehicle: { type: 'wagon', color: 'purple', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'aqua', direction: -1 } },
      ],
      'fill',
    ),
  ],
  goal: {
    sequence: ['aqua', 'purple'],
    message: `When you stop on sidings, click on wagons to uncouple them`,
    messageTouch: `When you stop on sidings, tap on wagons to uncouple them`,
  },
}

export const tutorial5: LevelConfig = {
  grid: [
    [null, null, null, 'SE', 'WE', 'WE', 'WE', 'SW'],
    padRow(
      [
        'W',
        { track: 'WE', vehicle: { type: 'locomotive' } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'lawngreen' } },
        ['WE', 'NW'],
        'WE',
        'WE',
        'WE',
        ['WE', 'NE'],
        { track: 'WE', exit: 'E' },
      ],
      'append',
    ),
  ],
  goal: {
    sequence: ['lawngreen'],
    message: `Wagons can be coupled
from the front or the rear`,
    messageTouch: `Wagons can be coupled
from the front or the rear`,
  },
}
